import { Injectable } from '@angular/core';
import {
    EntityAction,
    EntityCollection,
    EntityCollectionReducerMethodMap,
    EntityCollectionReducerMethods,
    EntityDefinition,
    EntityDefinitionService
} from '@ngrx/data';

@Injectable()
export class WebSocketEntityCollectionReducerMethodsFactory {
    constructor(private entityDefinitionService: EntityDefinitionService) {
    }

    /** Create the {EntityCollectionReducerMethods} for the named entity type */
    create<T>(entityName: string): EntityCollectionReducerMethodMap<T> {
        const definition = this.entityDefinitionService.getDefinition<T>(entityName);
        const methodsClass = new WebSocketEntityCollectionReducerMethods(entityName, definition);

        return methodsClass.methods;
    }
}

export class WebSocketEntityCollectionReducerMethods<T> extends EntityCollectionReducerMethods<T> {
    constructor(public entityName: string, public definition: EntityDefinition<T>) {
        super(entityName, definition);
    }

    protected queryManySuccess(collection: EntityCollection<T>, action: EntityAction<Array<T>>
    ): EntityCollection<T> {
        const entityCollection = super.queryManySuccess(collection, action);

        if ((action.payload as any).data.additional) {
            // There is no EntityOp or EntityAction for setting additionalCollectionState properties, so we use this
            // reducer to set e.g. 'refreshing' flag by faking a call to the backend resulting in an action
            // with additional parameters.
            const additional = (action.payload as any).data.additional;
            Object.keys(additional)
                .forEach(key => {
                    (entityCollection as any)[key] = additional[key];
            });
        } else {
            // Response is from backend - so we reset the refreshing flag
            (entityCollection as any).refreshing = false;

            // getWithQuery() returns (via observable) an array, so the only way to include additional parameters
            // like queryFilter from the reponse from the backend is to add as properties to the array
            // so here we extract the queryFilter, if any, and set on on the collection (additionalCollectionState)
            if ((action.payload as any).data.queryFilter) {
                (entityCollection as any).queryFilter = (action.payload as any).data.queryFilter;
            }

            // This is map total recalls for dashboard
            if ((action.payload as any).data.totalRecallsCount) {
                (entityCollection as any).totalRecallsCount = (action.payload as any).data.totalRecallsCount;
            }

            // This is map total missed for dashboard
            if ((action.payload as any).data.totalMissedCount) {
                (entityCollection as any).totalMissedCount = (action.payload as any).data.totalMissedCount;
            }

        }

        return entityCollection;
    }

    protected removeAll(
        collection: EntityCollection<T>,
        action: EntityAction<T>
    ): EntityCollection<T> {
        const updatedCollection = super.removeAll(collection, action);
        (updatedCollection as any).queryFilter = undefined;

        return updatedCollection;
    }
}
